import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';

import { TimeInput } from '../time-input/time-input.component';


/**
 * Módulo del componente TimeInptu.
 *
 * @export
 * @class TimeInputModule
 */
@NgModule({
  declarations: [
    TimeInput
  ],
  providers: [
  ],
  imports: [
    IonicModule,
  ],
  entryComponents: [
    TimeInput
  ],
  exports: [
    TimeInput
  ]
})

export class TimeInputModule{ }



// WEBPACK FOOTER //
// ./src/modules/utils/time-input/time-input.module.ts